import { render, staticRenderFns } from "./FlagIcon.vue?vue&type=template&id=3cfa3b30&scoped=true&"
import script from "./FlagIcon.vue?vue&type=script&lang=js&"
export * from "./FlagIcon.vue?vue&type=script&lang=js&"
import style0 from "./FlagIcon.vue?vue&type=style&index=0&id=3cfa3b30&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cfa3b30",
  null
  
)

export default component.exports